/**
 * Global consent-gate Zustand store.
 *
 * google-sign-in/US-004 (T5): Implements the frontend side of API-004 (the
 * cross-cutting 403 CONSENT_REQUIRED gate). Bridges the axios response
 * interceptor (a module, not a component — must use getState()/setState()
 * rather than the hook) and the app-wide ConsentModal (a React component —
 * uses the hook). Mirrors the useAuthStore create<State>() pattern in
 * frontend/src/hooks/useAuth.ts verbatim.
 *
 * AC-004.6: this store is UI CONVENIENCE ONLY. Enforcement is entirely
 * server-side (TS-004's require_consent); nothing in this store can grant
 * access to a gated endpoint — it only decides whether the blocking modal
 * is shown.
 */

import { create } from 'zustand';

interface ConsentGateState {
  /** True when the interceptor has observed a 403 CONSENT_REQUIRED response. */
  consentRequired: boolean;
  setConsentRequired: (value: boolean) => void;
  clearConsentRequired: () => void;
}

export const useConsentGateStore = create<ConsentGateState>((set) => ({
  consentRequired: false,
  setConsentRequired: (value) => set({ consentRequired: value }),
  clearConsentRequired: () => set({ consentRequired: false }),
}));
